import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CustomModal from "components/Modals/CustomModal";
import { getPathPrefix } from "utils/coreUtils";

const RuleEngineActions = ({
  actionId,
  classes = "",
  editPath,
  canEdit = true,
  viewPath,
  deleteMessage,
  deleteId,
  deleteHandler,
  canDelete = true,
  additonalActions = [],
}) => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const actions = useMemo(() => {
    const editAction = (
      <OverlayTrigger
        placement="auto"
        overlay={(props) => (
          <Tooltip id="edit-tooltip" {...props}>
            {t("versionsForm.tooltip.edit")}
          </Tooltip>
        )}
      >
        <span className="action-icon">
          <button
            onClick={() => {
              navigate(getPathPrefix(editPath));
            }}
            disabled={!canEdit}
          >
            <i className="fa-regular fa-edit"></i>
          </button>
        </span>
      </OverlayTrigger>
    );
    const viewAction = (
      <OverlayTrigger
        placement="auto"
        overlay={(props) => (
          <Tooltip id="view-tooltip" {...props}>
            {t("versionsForm.tooltip.view")}
          </Tooltip>
        )}
      >
        <span className="action-icon">
          <button
            onClick={() => {
              navigate(getPathPrefix(viewPath));
            }}
          >
            <i className="fa-regular fa-eye"></i>
          </button>
        </span>
      </OverlayTrigger>
    );
    const deleteAction = (
      <OverlayTrigger
        placement="auto"
        overlay={(props) => (
          <Tooltip id="delete-tooltip" {...props}>
            {t("versionsForm.tooltip.delete")}
          </Tooltip>
        )}
      >
        <span className="action-icon">
          <button
            onClick={() => {
              setShowDelete(true);
            }}
            disabled={!canDelete}
          >
            <i className="fa-regular fa-trash-can"></i>
          </button>
        </span>
      </OverlayTrigger>
    );
    const actionList = [editAction, viewAction, deleteAction];
    if (additonalActions.length > 0) {
      additonalActions.forEach((action) => {
        actionList.splice(action.sequence, 0, action.action);
      });
    }
    return actionList;
  }, [additonalActions, canDelete, canEdit, editPath, navigate, t, viewPath]);
  return (
    <>
      <div
        className={`row gap-2 justify-content-center align-items-center ${classes}`}
      >
        {actions.map((action, index) => (
          <React.Fragment key={`${actionId}-${index}`}>{action}</React.Fragment>
        ))}
      </div>
      <CustomModal
        show={showDelete}
        centered
        noHeader
        body={
          <h5
            className="modal-title text-center w-100"
            style={{ color: "#004e5c" }}
          >
            {deleteMessage}
          </h5>
        }
        okTitle={t("CommonKeys.yes")}
        cancelTitle={t("CommonKeys.no")}
        centerFooter
        onOk={() => {
          deleteHandler(deleteId);
          setShowDelete(false);
        }}
        onCancel={() => {
          setShowDelete(false);
        }}
      />
    </>
  );
};

export default RuleEngineActions;
